import { gql } from "@apollo/client";

export const ACTIONS_FOR_EMPLOYEE = gql`
  query Actions_for_employee(
    $logged_in_uuid: UUID!
    $agency_id: Int!
    $action_count_date: Date!
  ) {
    actions_for_employee(
      logged_in_uuid: $logged_in_uuid
      agency_id: $agency_id
      action_count_date: $action_count_date
    ) {
      status
      status_code
      message
      actions {
        name
        action_count
      }
    }
  }
`;

export const GET_MEETINGS_BY_DATE = gql`
  query MeetingsByDate(
    $start_date: DateTime!
    $end_date: DateTime!
    $employee_uuid: String!
    $page: Int!
    $page_size: Int!
    $agency_id: Int!
  ) {
    meetings_by_date_employee(
      start_date: $start_date
      end_date: $end_date
      employee_uuid: $employee_uuid
      page: $page
      page_size: $page_size
      agency_id: $agency_id
    ) {
      meetings {
        meeting_id
        title
        description
        start_date
        end_date
        meeting_hours
        meeting_minutes
        reminder
        is_reminder
        meeting_host_uuid
        meeting_url
        upcoming_status
        members {
          employee_uuid
          first_name
          last_name
          middle_name
          email_id
        }
      }
      status
      status_code
      message
      pagination {
        total_pages
        current_page
        total_items
        has_next
        has_previous
      }
    }
  }
`;

export const GET_TASKS_BY_EMPLOYEE_ID = gql`
  query GetTasksByEmployeeId(
    $client_location_id: Int!
    $employee_id: String!
    $page: Int!
    $page_size: Int!
  ) {
    get_tasks_by_employee_id(
      client_location_id: $client_location_id
      employee_id: $employee_id
      page: $page
      page_size: $page_size
    ) {
      status
      message
      status_code
      data {
        id
        employee_id
        task_date
        task_name
        task_status
        notes
        client_location_id
        start_date
        end_date
        reason
        created_by
        created_on
        updated_by
        updated_on
        task_type
        created_by_first_name
        created_by_middle_name
        created_by_last_name
        is_readonly
      }
      page
      page_size
      total_records
      total_pages
    }
  }
`;

export const GET_TASKS_STATUS = gql`
  query Tasksstatus {
    tasksstatus_enum
  }
`;

export const ALERT_CAREGIVER_DOCUMENT_EXPIRE = gql`
  query Alert_caregiver_document_expire(
    $agency_id: Int!
    $page: Int
    $page_size: Int
  ) {
    alert_caregiver_document_expire(
      agency_id: $agency_id
      page: $page
      page_size: $page_size
    ) {
      status
      message
      status_code
      page
      page_size
      total_records
      total_pages
      data {
        id
        caregiver_uuid
        url
        tag_name
        created_by
        created_on
        document_name
        expire_date
        first_name
        middle_name
        last_name
      }
    }
  }
`;

export const CLIENT_WITHOUT_SHIFTS_30_DAYS = gql`
  query Clients_without_shift_30_days($input: ClientWithoutShiftsInput!) {
    clients_without_shift_30_days(input: $input) {
      status
      status_code
      message
      new_clients {
        uuid
        client_name
        email_id
        mobile_number
        action
        created_on
      }
      pagination {
        total_pages
        current_page
        total_items
        has_next
        has_previous
      }
    }
  }
`;

export const CLIENTS_WITHOUT_SHIFT_7_DAYS = gql`
  query Clients_without_shift_7_days($input: ClientWithoutShiftsInput!) {
    clients_without_shift_7_days(input: $input) {
      status
      status_code
      message
      active_clients {
        uuid
        client_name
        start_date
        last_shift
        action
      }
      pagination {
        total_pages
        current_page
        total_items
        has_next
        has_previous
      }
    }
  }
`;

export const GET_CAREGIVERS_WITHOUT_SHIFTS = gql`
  query Get_caregivers_without_shifts($input: ClientWithoutShiftsInput!) {
    get_caregivers_without_shifts(input: $input) {
      status
      status_code
      message
      pagination {
        total_pages
        current_page
        total_items
        has_next
        has_previous
      }
      caregivers_no_recent_appointments {
        uuid
        first_name
        middle_name
        last_name
        mobile_number
        status
        email_id
        start_of_case
      }
    }
  }
`;

export const GET_EARLY_LATE_CLOCKIN_CLOCKOUT_DASHBOARD = gql`
  query Get_early_late_clockin_clockout_dashboard(
    $agency_id: Int!
    $start_date: DateTime!
    $end_date: DateTime!
    $logged_scheduler_id: String!
    $status: String
    $page: Int
    $page_size: Int
  ) {
    get_early_late_clockin_clockout_dashboard(
      agency_id: $agency_id
      start_date: $start_date
      end_date: $end_date
      logged_scheduler_id: $logged_scheduler_id
      status: $status
      page: $page
      page_size: $page_size
    ) {
      status
      message
      data {
        id
        care_client_uuid
        start_appointment_date
        end_appointment_date
        care_client_name
        client_location_id
        agency_id
        status
        caregiver_uuid
        cancel_by
        cancel_date
        cancel_reason
        shift_id
        call_type_id
        approval_status
        pay_rate
        bill_rate
        mgmt_rates_id
        mgmt_payroll_id
        payroll_status
        caregiver_over_time_hour
        approval_type
        is_facility
        facility_shift_id
        caregiver_approval_type
        caregiver_approval_status
        caregiver_approval_by
        caregiver_approval_time
        care_client_approval_by
        care_client_approval_time
        care_plan_id
        care_notes
        holiday_bill_rate
        holiday_pay_rate
        is_holiday
        facility_rate_type
        facility_time_type
        miles_rate
        payable_miles_rate
        payroll_roundoff
        created_on
        created_by
        updated_on
        updated_by
        is_invoice
        appointment_hours
        appointment_minutes
        first_name
        middle_name
        last_name
        mobile_number
        unit_multiplier
        eary_late_clokin_clockout_flag
        clockin_clockout_flag
        appointmentsclockinouttype_set {
          id
          caregiver_uuid
          client_location_id
          check_in_time
          check_out_time
          status
          in_latitude
          in_longitude
          out_latitude
          out_longitude
          care_client_uuid
          appointment_id
          checked_by
          clock_in_over_rule
          clock_out_over_rule
          check_in_distance
          check_out_distance
          clock_in_reason
          clock_out_reason
          check_in_address
          check_out_address
          additional_info
          additional_info_clock_out
          clock_in_time
          clock_in_by
          clock_out_time
          clock_out_by
          client_clock_in_address
          client_clock_out_address
          client_in_latitude
          client_in_longitude
          client_out_latitude
          client_out_longitude
          actual_check_in_time
          actual_check_out_time
          in_distance_matrix_call
          out_distance_matrix_call
          created_by
          created_on
        }
      }
      pagination {
        total_pages
        current_page
        total_items
        has_next
        has_previous
      }
    }
  }
`;

export const GET_MISSED_CLOCKIN_CLOCKOUT_DASHBOARD = gql`
  query Get_missed_clockin_clockout_dashboard(
    $agency_id: Int!
    $start_date: DateTime!
    $end_date: DateTime!
    $status: String
    $search_type: String!
    $logged_scheduler_id: String!
    $page: Int
    $page_size: Int
  ) {
    get_missed_clockin_clockout_dashboard(
      agency_id: $agency_id
      start_date: $start_date
      end_date: $end_date
      status: $status
      search_type: $search_type
      logged_scheduler_id: $logged_scheduler_id
      page: $page
      page_size: $page_size
    ) {
      status
      message
      data {
        id
        care_client_uuid
        start_appointment_date
        end_appointment_date
        care_client_name
        client_location_id
        agency_id
        status
        caregiver_uuid
        cancel_by
        cancel_date
        cancel_reason
        shift_id
        call_type_id
        approval_status
        pay_rate
        bill_rate
        mgmt_rates_id
        mgmt_payroll_id
        payroll_status
        caregiver_over_time_hour
        approval_type
        is_facility
        facility_shift_id
        caregiver_approval_type
        caregiver_approval_status
        caregiver_approval_by
        caregiver_approval_time
        care_client_approval_by
        care_client_approval_time
        care_plan_id
        care_notes
        holiday_bill_rate
        holiday_pay_rate
        is_holiday
        facility_rate_type
        facility_time_type
        miles_rate
        payable_miles_rate
        payroll_roundoff
        created_on
        created_by
        updated_on
        updated_by
        is_invoice
        appointment_hours
        appointment_minutes
        first_name
        middle_name
        last_name
        mobile_number
        unit_multiplier
        eary_late_clokin_clockout_flag
        clockin_clockout_flag
      }
      pagination {
        total_pages
        current_page
        total_items
        has_next
        has_previous
      }
    }
  }
`;

export const OPEN_SHIFT_ALERTS = gql`
  query Open_shift_alerts(
    $agency_id: Int!
    $logged_in_uuid: UUID!
    $page: Int
    $page_size: Int
  ) {
    open_shift_alerts(
      agency_id: $agency_id
      logged_in_uuid: $logged_in_uuid
      page: $page
      page_size: $page_size
    ) {
      status
      message
      status_code
      page
      page_size
      total_records
      total_pages
      data {
        client_uuid
        client_first_name
        client_middle_name
        client_last_name
        client_mobile_number
        start_appointment_date
        end_appointment_date
        appointments_id
      }
    }
  }
`;

export const SAFE_SHIFT_ALERTS = gql`
  query Safe_shift_alerts(
    $agency_id: Int!
    $logged_in_uuid: UUID!
    $page: Int
    $page_size: Int
  ) {
    safe_shift_alerts(
      agency_id: $agency_id
      logged_in_uuid: $logged_in_uuid
      page: $page
      page_size: $page_size
    ) {
      status
      message
      status_code
      page
      page_size
      total_records
      total_pages
      data {
        caregiver_uuid
        caregiver_first_name
        caregiver_middle_name
        caregiver_last_name
        caregiver_mobile_number
        client_uuid
        client_first_name
        client_middle_name
        client_last_name
        appointment_date
        notes
      }
    }
  }
`;

//wizkind API
export const REQUEST_OTP = gql`
  query Request_otp(
    $action: String!
    $varification_type: String!
    $email: String
  ) {
    request_otp(
      action: $action
      varification_type: $varification_type
      email: $email
    ) {
      status
      message
      status_code
    }
  }
`;

export const PROJECTS_BY_EMP_ID = gql`
  query Projects_by_emp_id($emp_id: String!, $organization_id: String!) {
    projects_by_emp_id(emp_id: $emp_id, organization_id: $organization_id) {
      id
      name
      status_change_date
      created_on
      updated_on
      created_by
      status_id
      updated_by
      is_default
      tagline
      niche
      ideal_customer_profile
      unique_about_it
      image_url
      members {
        id
        member_name
        employee_id
      }
      created_by_name
    }
  }
`;

export const GOAL_MASTER_DATA = gql`
  query Goal_master_data($goal_for: String) {
    goal_master_data(goal_for: $goal_for) {
      status
      message
      status_code
      goals_static {
        id
        name
        status
        created_by
        created_on
        updated_by
        updated_on
        goal_for
        outcome
        tasks {
          id
          name
          status
          created_by
          created_on
          updated_by
          updated_on
          role_name
          checklists {
            id
            name
            status
            created_by
            created_on
            updated_by
            updated_on
          }
        }
      }
    }
  }
`;

export const GOAL_BY_STATIC_GOAL_ID = gql`
  query Goals_by_static_goal_id($static_goal_id: Int!, $project_id: Int) {
    goals_by_static_goal_id(
      static_goal_id: $static_goal_id
      project_id: $project_id
    ) {
      status
      message
      status_code
      goals {
        id
        title
        goal_score
        is_archive
        start_date
        end_date
        created_by
        created_on
        updated_by
        updated_on
        description
        created_by_name
        project_id
        goals_static_id
        tasks {
          id
          title
          dependency_task_id
        }
        goal_members {
          id
          employee_name
          employee_id
        }
      }
    }
  }
`;

export const TASKS_BY_EMPLOYEE_ID = gql`
  query Tasks_by_employee_id($employee_id: Int!) {
    tasks_by_employee_id(employee_id: $employee_id) {
      status
      message
      status_code
      tasks {
        id
        title
        start_datetime
        end_datetime
        is_independent
        current_status_id
        current_status_updated_by
        current_status_updated_on
        priority
        created_by
        created_on
        updated_by
        updated_on
        days
        hours
        mins
        dependency_task_id
        dependency_task_name
        goal_id
        goals_static_id
        tasks_static_id
        assigned_to_id
        status_name
        created_by_name
        assigned_to_name
        static_task_type_name
        project_name
        goal_name
        task_tags {
          id
          created_on
          created_by
          tags_name
        }
      }
    }
  }
`;

export const TASK_BY_TASK_ID = gql`
  query Task_by_task_id($task_id: Int!) {
    task_by_task_id(task_id: $task_id) {
      id
      title
      start_datetime
      end_datetime
      is_template
      is_independent
      current_status_id
      current_status_updated_by
      current_status_updated_on
      priority
      created_by
      created_on
      updated_by
      updated_on
      days
      hours
      mins
      dependency_task_id
      dependency_task_name
      goal_id
      goals_static_id
      tasks_static_id
      assigned_to_id
      status_name
      created_by_name
      assigned_to_name
      static_task_type_name
      project_name
      goal_name
      task_note
      goal_description
         pod_id
        pod_name
            goal_start_date
        goal_end_date
      skills {
        id
        skill_name
        skill_id
      }
      checklist_items {
        id
        status
        created_date
        created_by
        update_date
        updated_by
        checklist_name
        checklist {
          id
        }
      }
      activities {
        id
        comment
        created_on
        created_by
        time_spent_hr
        time_spent_min
        status_name
        created_by_name
      }
      task_tags {
        id
        created_on
        created_by
        tags_name
      }
      goal_start_date
      goal_end_date
      project_id
      goal_static_type_name
      project_members {
        id
        member_name
        employee_id
      }
                goal_skills {
            id
            created_on
            created_by
            skill_name
            skill_id
        }
    }
  }
`;

export const MASTER_STATUS_VALUES = gql`
  query Master_status_values {
    master_status_values {
      status
      message
      status_code
      status_values {
        id
        name
        type
        value
      }
    }
  }
`;

export const CLOCK_OUT_TASK_BY_EMPLOYEE_ID = gql`
  query Clock_out_tasks_by_employee_idi($employee_id: Int!, $agency_id: Int) {
    clock_out_tasks_by_employee_id(
      employee_id: $employee_id
      agency_id: $agency_id
    ) {
      status
      message
      status_code
      tasks {
        id
        title
        start_datetime
        end_datetime
        is_independent
        current_status_id
        current_status_updated_by
        current_status_updated_on
        priority
        created_by
        created_on
        updated_by
        updated_on
        days
        hours
        mins
        dependency_task_id
        goal_id
        goals_static_id
        tasks_static_id
        assigned_to_id
        status_name
        created_by_name
        assigned_to_name
        static_task_type_name
        project_name
        goal_name
        today_spent_hours
        today_spent_minutes
              activities {
                id
                comment
                created_on
                created_by
                time_spent_hr
                time_spent_min
                status_name
                created_by_name
            }
        checklist_items {
          id
          status
          created_date
          created_by
          update_date
          updated_by
          checklist_name
        }
        task_tags {
          id
          created_on
          created_by
          tags_name
        }
      }
    }
  }
`;

export const TODAY_CLOCK_IN = gql`
  query Today_clock_in_out($employee_id: Int!, $agency_id: Int!) {
    today_clock_in_out(employee_id: $employee_id, agency_id: $agency_id) {
      status
      message
      status_code
      clock_in {
        id
        employees_id
        check_in_time
        check_out_time
        is_check_in
        in_latitude
        in_longitude
        out_latitude
        out_longitude
        agencies_id
        checked_by
        status
        is_payroll
        check_in_distance
        check_out_distance
        check_in_address
        check_out_address
        clock_out_comment
        minutes
        is_clock_out_notification_send
        hours
        is_auto_clock_out
        is_auto_clock_out_task_update_enable
        created_by
        created_on
        updated_by
        updated_on
      }
      breaks {
        id
        start_time
        end_time
        in_latitude
        in_longitude
        out_latitude
        out_longitude
        agencies_id
        status
        is_break_in
        break_start_address
        break_end_address
        created_by
        created_on
        updated_by
        updated_on
        clock_in_id
      }
    }
  }
`;

export const PROJECT_GOALS = gql`
  query Project_goals(
    $project_id: Int!
    $is_archived: Boolean
    $employee_id: Int
    $goal_for: String
    $start_date: Date
    $end_date: Date
  ) {
    project_goals(
      project_id: $project_id
      is_archived: $is_archived
      employee_id: $employee_id
      goal_for: $goal_for
      start_date: $start_date
      end_date: $end_date
    ) {
      status
      message
      status_code
      grouped_goals {
        status_name
        status_id
        goals {
          id
          title
          is_template
          goal_score
          is_archive
          start_date
          end_date
          created_by
          created_on
          updated_by
          updated_on
          description
          created_by_name
          project_id
          project_name
          goals_static_id
          goal_static_name
          number_of_tasks
          number_of_completed_tasks
          goal_status
          actual_start_date
          actual_end_date
          goal_members {
            id
            member_name
            employee_id
          }
          goal_tags_values {
            id
            created_on
            tags_name
          }
          goal_static_outcome
        }
      }
    }
  }
`;

export const GOAL_DETAILS = gql`
  query Goal_details($goal_id: Int!) {
    goal_details(goal_id: $goal_id) {
      status
      message
      status_code
      project_members {
            id
            member_name
            employee_id
        }
      goal_details {
        id
        title
        pod_id
        pod_name
        template_tag
        goal_score
        is_archive
        start_date
        end_date
        created_by
        created_on
        updated_by
        updated_on
        description
        what_building
        created_by_name
        project_id
        project_name
        goals_static_id
        number_of_tasks
        number_of_completed_tasks
        actual_start_date
        actual_end_date
        static_goal_type_name
        links
        is_template
        skills {
          id
          skill_name
          skill_id
        }
        attachments {
          id
          file_name
          file_path
          file_type
          uploaded_at
          goal_id
        }
               defect {
                   module
                classification_type
                symptom
                request_type
                flags
                channels
                churn_quote
                category
                updated_by
                updated_on
                item_code
                recurrence_count
                ticket_id
                agency_name
                screen_name
                template_name
            }
        tasks {
          id
          title
          start_datetime
          end_datetime
          is_independent
          current_status_id
          current_status_updated_by
          current_status_updated_on
          priority
          created_by
          created_on
          updated_by
          updated_on
          days
          hours
          mins
          dependency_task_id
          goal_id
          goals_static_id
          tasks_static_id
          assigned_to_id
          status_name
          created_by_name
          assigned_to_name
          static_task_type_name
          project_name
          goal_name
          task_note
          skills {
            id
            skill_name
            skill_id
          }
          task_tags {
            id
            created_on
            created_by
            tags_name
          }
          activities {
            id
            comment
            created_on
            created_by
            time_spent_hr
            time_spent_min
            status_name
            created_by_name
          }
          checklist_items {
            id
            status
            created_date
            created_by
            update_date
            updated_by
            checklist_name
            checklist {
              id
            }
          }
        }
        goal_tags_values {
          id
          created_on
          tags_name
        }
        task_status_values {
          id
          comment
          created_on
          created_by
          time_spent_hr
          time_spent_min
          status_name
          created_by_name
        }
        goal_members {
          id
          member_name
          employee_id
          roles
        }
      }
    }
  }
`;

export const NOT_YET_STARTED_TASKS = gql`
  query Not_yet_started_tasks($date: DateTime, $page: Int, $page_size: Int) {
    not_yet_started_tasks(date: $date, page: $page, page_size: $page_size) {
      status
      message
      status_code
      tasks {
        id
        title
        start_datetime
        end_datetime
        is_independent
        current_status_id
        current_status_updated_by
        current_status_updated_on
        priority
        created_by
        created_on
        updated_by
        updated_on
        days
        hours
        mins
        assigned_to_id
        goal_id
        project_name
        created_by_name
        members {
          id
          member_name
        }
      }
      pagination {
        total_pages
        current_page
        total_items
        has_next
        has_previous
      }
    }
  }
`;

export const EMPLOYEES_BY_AGENCY_ID = gql`
  query Employees_by_agency_id($agency_id: Int!) {
    employees_by_agency_id(agency_id: $agency_id) {
      status
      message
      status_code
      employees {
        employee_id
        first_name
        last_name
        email_id
        uuid
      }
    }
  }
`;

export const DEPENDENCIES = gql`
  query Dependencies($page: Int, $page_size: Int) {
    dependencies(page: $page, page_size: $page_size) {
      status
      message
      status_code
      dependencies {
        id
        task_id
        dependency_reason
        is_resolved
        created_by
        created_date
        dependent_person_id
        blocking_person_id
        dependent_person_name
        blocking_person_name
        task_title
      }
      pagination {
        total_pages
        current_page
        total_items
        has_next
        has_previous
      }
    }
  }
`;

export const DELAYS = gql`
  query Delays($date: Date, $page: Int, $page_size: Int) {
    delays(date: $date, page: $page, page_size: $page_size) {
      status
      message
      status_code
      tasks {
        id
        title
        start_datetime
        end_datetime
        is_independent
        current_status_id
        current_status_updated_by
        current_status_updated_on
        priority
        created_by
        created_on
        updated_by
        updated_on
        days
        hours
        mins
        assigned_to_id
        goal_id
        goal_name
        project_name
        assigned_to_name
        created_by_name
      }
      pagination {
        total_pages
        current_page
        total_items
        has_next
        has_previous
      }
    }
  }
`;

export const DEFECTS = gql`
  query Defects(
    $page: Int
    $page_size: Int
    $is_resolved: Boolean
    $defect_id: ID
    $is_confirmed: Boolean
    $is_issue: Boolean
    $filter_input:String
    $replied_by_employee_id:Int
    $is_approved:Boolean
    $start_date:Date
    $end_date:Date
  ) {
    defects(
      page: $page
      page_size: $page_size
      is_resolved: $is_resolved
      defect_id: $defect_id
      is_confirmed: $is_confirmed
      is_issue: $is_issue
      filter_input:$filter_input
      replied_by_employee_id:$replied_by_employee_id
      is_approved:$is_approved
      start_date:$start_date
      end_date:$end_date
    ) {
      status
      message
      status_code
      pagination {
        total_pages
        current_page
        total_items
        has_next
        has_previous
      }
      defects {
         id
         pod_goal_id
         is_template
            reference_id
            reference_name
            title
            description
            severity
            is_resolved
            created_by
            created_on
            is_issue
            is_confirmed
            confirmed_by
            steps_to_reproduce
            expected_behavior
            actual_behavior
            screen_name
            reporter_name
            agency_name
            action_type
            is_goal_exist
            goal_id
            reporter_email
            project_name
            module
            classification_type
            symptom
            request_type
            flags
            churn_quote
            category
            confidence
            agency_id
            item_code
            recurrence_count
            last_seen_on
            channels
            proposed_module
            proposed_symptom
            overturned_by
            screen_members
            pod_id
            goal_status
            is_approved
            defect_summary
            resolutions {
                id
                resolved_by
                resolved_on
                resolution_note
                file_name
                file_url
                approved_notes
                approved_file_url
                defect_id
                approved_by
                approved_on
            }
            attachments_list {
                id
                file_name
                file_url
                uploaded_by
                uploaded_on
                defect_id
            }
      }
    }
  }
`;

export const SEVERITY_LEVELS = gql`
  query Severity_levels {
    severity_levels
  }
`;

export const CLOCK_INS_BY_EMPLOYEE_ID = gql`
  query Clock_ins_by_employee_id(
    $employee_id: Int!
    $start_date: Date
    $end_date: Date
  ) {
    clock_ins_by_employee_id(
      employee_id: $employee_id
      start_date: $start_date
      end_date: $end_date
    ) {
      status
      message
      status_code
      clock_ins {
        id
        employees_id
        check_in_time
        check_out_time
        is_check_in
        agencies_id
        checked_by
        status
        clock_out_comment
        minutes
        is_clock_out_notification_send
        hours
        is_auto_clock_out
        is_auto_clock_out_task_update_enable
        created_by
        created_on
        updated_by
        updated_on
        week_day
        is_extra_day
        is_night_shift
      }
      missed_clock_ins {
        missed_date
        is_holiday
        on_leave
        is_weekend
        week_day
      }
    }
  }
`;

export const LEAVES_BY_AGENCY = gql`
  query Leaves_by_agency(
    $agency_id: ID!
    $start_date: DateTime
    $end_date: DateTime
    $leave_status: [String]
  ) {
    leaves_by_agency(
      agency_id: $agency_id
      start_date: $start_date
      end_date: $end_date
      leave_status: $leave_status
    ) {
      status
      message
      status_code
      total_approved
      total_pending
      leaves {
        id
        start_date
        end_date
        leave_type
        notes
        status
        reason
        created_by
        created_on
        updated_by
        updated_on
        employee_name
      }
    }
  }
`;

export const DASHBOARD_COUNTERS = gql`
  query Dashboard_counters($date: Date!, $agency_id: Int!) {
    dashboard_counters(date: $date, agency_id: $agency_id) {
      status
      message
      status_code
      dashboard_counters {
        delays_count
        dependencies_count
        defects_count
        today_leave_counts
        next_seven_days_leave_counts
        breaks_count
        upcoming_feature_counts
        bugs_count
        enhancements_count
        follow_up_count
        training_issue_count

      }
    }
  }
`;

export const BUGS = gql`
  query Bugs(
    $page: Int
    $page_size: Int
    $bug_status: String
    $priority: String
  ) {
    bugs(
      page: $page
      page_size: $page_size
      bug_status: $bug_status
      priority: $priority
    ) {
      status
      status_code
      pagination {
        total_items
        total_pages
        current_page
        has_next
        has_previous
      }
      bugs {
        id
        bug_date
        reported_by
        reported_by_name
        agency_id
        agency_name
        platform
        priority
        bug_details
        bug_assigned
        bug_assigned_name
        bug_status
        release_date
        remarks
      }
    }
  }
`;

export const ENHANCEMENTS = gql`
  query Enhancements(
    $page: Int
    $page_size: Int
    $enhancement_status: String
    $priority: String
  ) {
    enhancements(
      page: $page
      page_size: $page_size
      enhancement_status: $enhancement_status
      priority: $priority
    ) {
      status
      status_code
      pagination {
        total_items
        total_pages
        current_page
        has_next
        has_previous
      }
      enhancements {
            id
            enhancement_reported_on
            reported_by
            agency_id
            external_agency_id
            agency_name
            platform
            priority
            enhancement_details
            enhancement_assigned
            enhancement_status
            estimated_given_date
            work_started_on
            release_date
            remarks
            created_by
            created_on
            updated_by
            updated_on
            reported_by_name
            enhancement_assigned_name
        }
    }
  }
`;

export const BUG_BY_ID = gql`
  query Bug_by_id($bug_id: Int!) {
    bug_by_id(bug_id: $bug_id) {
      id
      bug_date
      reported_by
      reported_by_name
      agency_name
      platform
      priority
      bug_details
      bug_assigned
      bug_assigned_name
      bug_status
      release_date
      remarks
      history {
        id
        worked_by
        worked_by_name
        changes_made
        worked_on
        created_on
      }
    }
  }
`;

export const ENHANCEMENT_BY_ID = gql`
  query Enhancement_by_id($enhancement_id: Int!) {
    enhancement_by_id(enhancement_id: $enhancement_id) {
      id
        
        reported_by
        agency_id
        external_agency_id
        agency_name
        platform
        priority
        enhancement_details
        enhancement_assigned
        enhancement_status
        estimated_given_date
        work_started_on
        release_date
        remarks
        created_by
        created_on
        updated_by
        updated_on
        reported_by_name
        enhancement_assigned_name
        enhancement_reported_on
        history {
            id
            worked_by
            changes_made
            worked_on
            created_by
            created_on
            worked_by_name
            created_by_name
        }
    }
  }
`;

export const TODAY_BREAKS_BY_AGENCY = gql`
  query Today_breaks_by_agency($agency_id: Int!) {
    today_breaks_by_agency(agency_id: $agency_id) {
      status
      message
      status_code
      clock_in_breaks {
        id
        start_time
        end_time
        status
        is_break_in
        created_by
        created_on
        updated_by
        updated_on
        clock_in_id
        employee_name
      }
    }
  }
`;

export const EMPLOYEE_TASKS_LIST = gql`
  query Employee_tasks_list(
    $start_date: DateTime
    $end_date: DateTime
    $employee_id: Int
    $page: Int
    $page_size: Int
    $task_status: String
  ) {
    employee_tasks_list(
      start_date: $start_date
      end_date: $end_date
      employee_id: $employee_id
      page: $page
      page_size: $page_size
      task_status: $task_status
    ) {
      status
      message
      status_code
      tasks {
        id
        title
        start_datetime
        end_datetime
        is_independent
        current_status_id
        current_status_updated_by
        current_status_updated_on
        priority
        created_by
        created_on
        updated_by
        updated_on
        days
        hours
        mins
        assigned_to_id
        assigned_to_name
        goal_name
        goal_id
        project_name
        project_id
        current_status_name
        created_by_name
        task_tags
        static_task_type_name
      }
      pagination {
        total_pages
        current_page
        total_items
        has_next
        has_previous
      }
    }
  }
`;

export const EMPLOYEE_TASKS_LIST_CALENDAR = gql`
  query Employee_tasks_list(
    $start_date: DateTime
    $end_date: DateTime
    $employee_id: Int
    $page: Int
    $page_size: Int
    $task_status: String
  ) {
    employee_tasks_list(
      start_date: $start_date
      end_date: $end_date
      employee_id: $employee_id
      page: $page
      page_size: $page_size
      task_status: $task_status
    ) {
      status
      message
      status_code
      tasks {
        id
        title
        start_datetime
        end_datetime
        hours
        mins
        assigned_to_id
        goal_name
        project_name
        current_status_name
        static_task_type_name
        pod_id
      }
    }
  }
`;

export const GET_MEETINGS = gql`
  query Get_meetings(
    $agency_id: Int!
    $start_date: DateTime
    $end_date: DateTime
    $employee_id: Int
    $meeting_id: Int
    $meeting_type_ids: [Int]
    $goal_id: Int
  ) {
    get_meetings(
      agency_id: $agency_id
      start_date: $start_date
      end_date: $end_date
      employee_id: $employee_id
      meeting_id: $meeting_id
      meeting_type_ids: $meeting_type_ids
      goal_id: $goal_id
    ) {
      status
      message
      status_code
      meetings {
        id
        title
        pod_id
        start_datetime
        end_datetime
        is_deleted
        deleted_date
        meeting_link_string
        meeting_link_html
        event_type_text
        meeting_outcome
        is_email_send
        remind_time
        duration
        is_recurrence
        recurrence_id
        created_by
        created_date
        agency_id
        host_name
        status_name
        project_name
        goal_name
        project_id
        goal_id
        status_id
        meeting_outcome
        meeting_type_id
        meeting_type_name
        meeting_platform
        meeting_platform_id
        host {
          employee_id
        }
        members {
          id
          is_attended
          absent_note
          member_name
          employee_id
        }
        agendas {
          id
          title
          is_discussed
          agenda_id
        }
        external_members {
          id
          name
          email
          client_location_id
          is_attended
          absent_note
        }
      }
    }
  }
`;

export const MEETING_TYPES = gql`
  query Meeting_types {
    meeting_types {
      status
      message
      status_code
      meeting_types {
        id
        name
        description
        agendas {
          id
          agenda_item
          meeting_type_id
        }
      }
    }
  }
`;

export const MEETING_TYPES_CALENDAR = gql`
  query Meeting_types {
    meeting_types {
      status
      message
      status_code
      meeting_types {
        id
        name
      }
    }
  }
`;

export const TODOS = gql`
  query Todos($id: Int, $date: Date, $member_id: Int) {
    todos(id: $id, date: $date, member_id: $member_id) {
      status
      message
      status_code
      todos {
        id
        title
        description
        due_date
        is_completed
        completed_date
        created_by
        create_date
        updated_by
        updated_on
        is_email_send
        todo_assigned_user_name
        created_by_name
        meeting_title
        meeting_id
        description
        todo_assigned_user {
          employee_id
        }
      }
    }
  }
`;

export const LEAVES_BY_EMPLOYEE = gql`
  query Leaves_by_employee(
    $employee_id: ID!
    $start_date: DateTime!
    $end_date: DateTime!
  ) {
    leaves_by_employee(
      employee_id: $employee_id
      start_date: $start_date
      end_date: $end_date
    ) {
      status
      message
      status_code
      total_approved
      total_pending
      leaves {
        id
        start_date
        end_date
        leave_type
        notes
        status
        reason
        is_half_day
        employee_name
        pay_type
      }
    }
  }
`;

export const UPCOMING_FEATURES = gql`
  query Upcoming_features(
    $outcome: [String]!
    $pagination_input: PaginationInput
  ) {
    upcoming_features(outcome: $outcome, pagination_input: $pagination_input) {
      status
      message
      status_code
      goals {
        id
        title
        goal_score
        is_archive
        start_date
        end_date
        created_by
        created_on
        updated_by
        updated_on
        description
        created_by_name
        project_id
        goals_static_id
        number_of_tasks
        number_of_completed_tasks
        goal_status
        actual_start_date
        actual_end_date
        project_name
        goal_static_name
        goal_static_outcome
      }
      pagination {
        total_pages
        current_page
        total_items
        has_next
        has_previous
      }
    }
  }
`;

export const MEETING_TODO_DETAIL = gql`
  query Get_meetings(
    $agency_id: Int!
    $start_date: DateTime!
    $end_date: DateTime!
    $employee_id: Int
    $meeting_id: Int
    $meeting_type_ids: [Int]
  ) {
    get_meetings(
      agency_id: $agency_id
      start_date: $start_date
      end_date: $end_date
      employee_id: $employee_id
      meeting_id: $meeting_id
      meeting_type_ids: $meeting_type_ids
    ) {
      status
      message
      status_code
      meetings {
        id
        title
        start_datetime
        end_datetime
        is_deleted
        deleted_date
        meeting_link_string
        meeting_link_html
        event_type_text
        meeting_outcome
        is_email_send
        remind_time
        duration
        is_recurrence
        recurrence_id
        created_by
        created_date
        agency_id
        host_name
        status_name
        project_name
        goal_name
        project_id
        goal_id
        status_id
        meeting_outcome
        meeting_type_id
        meeting_type_name
        meeting_platform
        meeting_platform_id
        host {
          employee_id
        }
        members {
          id
          is_attended
          is_attended_temp
          absent_note
          member_name
          employee_id
        }
        agendas {
          id
          title
          is_discussed
          agenda_id
        }
        external_members {
          id
          name
          email
          client_location_id
          is_attended
          absent_note
        }
        todos {
          id
          title
          due_date
          is_completed
          completed_date
          todo_assigned_user_name
          created_by_name
          meeting_title
          meeting_id
        }
      }
    }
  }
`;

export const GET_CALENDAR_MEETINGS = gql`
  query Get_meetings(
    $agency_id: Int!
    $start_date: DateTime!
    $end_date: DateTime!
    $employee_id: Int
    $meeting_id: Int
    $meeting_type_ids: [Int]
  ) {
    get_meetings(
      agency_id: $agency_id
      start_date: $start_date
      end_date: $end_date
      employee_id: $employee_id
      meeting_id: $meeting_id
      meeting_type_ids: $meeting_type_ids
    ) {
      status
      message
      status_code
      meetings {
        id
        title
        start_datetime
        end_datetime
        host_name
        meeting_type_name
        is_deleted
        is_email_send
        pod_id
        members{
        employee_id
        }
      }
    }
  }
`;

export const GET_ALL_CUSTOMER_EMAILS = gql`
  query Get_all_customer_emails(
    $page: Int
    $page_size: Int
    $is_follow_up_required: Boolean
    $is_replied: Boolean
    $is_archived: Boolean
    $start_date: DateTime
    $end_date: DateTime
  ) {
    get_all_customer_emails(
      page: $page
      page_size: $page_size
      is_follow_up_required: $is_follow_up_required
      is_replied: $is_replied
      is_archived: $is_archived
      start_date: $start_date
      end_date: $end_date
    ) {
      status
      message
      status_code
      customer_emails {
        id
        email_retrieval_id
        message_id
        thread_id
        subject
        email_body
        sender_email
        receiver_email
        attachments_urls
        received_at
        label
        date
        employee_id
        agency_id
        agency_name
        agency_email
        is_replied
        reply_body
        replied_at
        replied_by
        created_at
        is_follow_up_required
        replies {
          body
          attachments_urls
        }
      }
      pagination {
        total_pages
        current_page
        total_items
        has_next
        has_previous
      }
    }
  }
`;

export const GET_ALL_TICKETS = gql`
  query Get_all_tickets($page: Int, $page_size: Int) {
    get_all_tickets(page: $page, page_size: $page_size) {
      status
      message
      status_code
      pagination {
        total_pages
        current_page
        total_items
        has_next
        has_previous
      }
      tickets {
        id
        ticket_id
        subject
        description
        status
        priority
        opened
        opened_at
        closed_at
        created_at
        customer_email_address
        thread_id_of_ticket_mail
        email_retrieval_id
        attachments_urls
      }
    }
  }
`;

export const GET_ALL_SKILLS = gql`
  query Get_all_skills {
    get_all_skills {
      status
      message
      status_code
      skills {
        id
        skill_name
        description
      }
    }
  }
`;

export const EMPLOYEE_BY_EMPLOYEE_ID = gql`
  query Employee_by_employee_id($employee_id: Int!) {
    employee_by_employee_id(employee_id: $employee_id) {
      status
      message
      status_code
      employees {
        pod_name
        employee_id
        sex
        dob
        date_of_joining
        designation
        address
        state_name
        city_id
        contact_no
        email_id
        emergency_contact_no
        emergency_contact_person
        salary
        image_url
        created_by
        created_on
        updated_by
        updated_on
        status
        password
        identifier
        device_registration_id
        address_line
        zip
        credentials
        last_login
        verapal_status
        time_zone
        independent_contractor
        password_salt
        uuid
        country
        inactive_reason
        device_type
        agency_location_id
        first_name
        last_name
        access_type
        external_employees_uuid
        is_imported_from_external
        sync_type
        ssn
        job_target_user_id
        paylocity_tracking_id
        paylocity_employee_id
        payee_tax_id_type
        is_exportkyck
        kyck_payee_id
        payment_mode
        employee_type
        inactive_secondary_reason
        is_request_accepted
        report_time
        is_request_rejected
        clock_out_hour
        clock_out_minute
        is_in_standing_meeting
        employee_roles
        is_agency
        skills {
          id
          proficiency_level
          years_of_experience
          certified
          assigned_date
          skill_name
          skill_id
        }
      }
    }
  }
`;

export const GET_RESOURCE_OVERVIEW = gql`
  query Get_resource_overview(
    $input_data: TimeAvailabilityResourceOverviewInputType!
  ) {
    get_resource_overview(input_data: $input_data) {
      status
      message
      status_code
      data {
        available_members_count
        total_members_count
        allocated_working_hours
        total_working_hours
        number_of_members_over_utilized
        members {
          employee_id
          first_name
          last_name
          email
          total_working_hours
          allocated_working_hours
          utilization_percentage
          is_over_utilized
          is_available
          skill_set
        }
      }
    }
  }
`;

export const GET_TASKS_FOR_TASK_AVAILABILITY = gql`
  query Employee_tasks_list(
    $start_date: DateTime
    $end_date: DateTime
    $employee_id: Int
  ) {
    employee_tasks_list(
      start_date: $start_date
      end_date: $end_date
      employee_id: $employee_id
    ) {
      status
      message
      status_code
      tasks {
        id
        title
        start_datetime
        end_datetime
        days
        hours
        mins
        assigned_to_id
        assigned_to_name
        current_status_name
        created_by_name
        task_tags
      }
    }
  }
`;

export const GET_MEETINGS_FOR_TASK_AVAILABILITY = gql`
  query Get_meetings(
    $agency_id: Int!
    $start_date: DateTime
    $end_date: DateTime
    $employee_id: Int
  ) {
    get_meetings(
      agency_id: $agency_id
      start_date: $start_date
      end_date: $end_date
      employee_id: $employee_id
    ) {
      status
      message
      status_code
      meetings {
        id
        title
        start_datetime
        end_datetime
        is_deleted
        deleted_date
        meeting_link_string
        meeting_link_html
        event_type_text
        meeting_outcome
        is_email_send
        remind_time
        duration
        host_name
        status_name
      }
    }
  }
`;

export const GET_TIME_AVAILABILITY_BY_EMPLOYEE_ID = gql`
  query Get_time_availability_by_employee_id(
    $employee_id: Int!
    $start_date: Date!
    $end_date: Date!
  ) {
    get_time_availability_by_employee_id(
      employee_id: $employee_id
      start_date: $start_date
      end_date: $end_date
    ) {
      status
      message
      status_code
      data {
        employee_id
        first_name
        last_name
        email
        total_working_hours
        allocated_working_hours
        utilization_percentage
        is_over_utilized
        is_available
        skill_set
        days {
          date
          is_holiday
          on_leave
          is_weekend
          week_day
          day_total_allocated_hours
        }
      }
    }
  }
`;

export const ALL_EMPLOYEE_CLOCK_INS_BY_AGENCY_ID = gql`
  query All_employee_clock_ins_by_agency_id(
    $agency_id: Int!
    $start_date: Date
    $end_date: Date
  ) {
    all_employee_clock_ins_by_agency_id(
      agency_id: $agency_id
      start_date: $start_date
      end_date: $end_date
    ) {
      status
      message
      status_code
      records {
        employee_id
        employee_name
        attendance {
          record_date
          week_day
          check_in_time
          check_out_time
          is_present
          is_leave
          is_holiday
          is_absent
          is_weekend
          is_half_day
          is_extra_day
          is_night_shift
        }
      }
    }
  }
`;

export const GET_CLIMBS = gql`
  query Get_climbs {
    get_climbs {
      status
      message
      status_code
      climbs {
        id
        name
        description
      }
    }
  }
`;

export const GET_IMPACT_LEVELS = gql`
  query Get_impact_levels {
    get_impact_levels {
      status
      message
      status_code
      impact_levels {
        id
        name
        description
      }
    }
  }
`;

export const GET_IDEA_GOAL = gql`
  query Get_idea_goal($id: Int!) {
    get_idea_goal(id: $id) {
      status
      message
      status_code
      idea_goal {
        id
        title
        project_id
        goals_static_id
        expected_closing_date
        priority
        user_selected
        created_at
        updated_at
        impact_level_name
        outcome_name
        project_name
        goals_static_name
        user_input
        links
        goal_for
        skills {
          id
          skill_id
          skill_name
        }
        attachments {
          id
          file_name
          file_path
          file_type
          uploaded_at
          idea_goal_id
        }
        goal_followers {
          id
          follower_user_id
          followed_at
          is_follow
          idea_goal_id
          employee_name
        }
      }
    }
  }
`;

export const GET_IDEA_GOALS = gql`
  query Get_idea_goals {
    get_idea_goals {
      status
      message
      status_code
      idea_goals {
        id
        title
        project_id
        goals_static_id
        expected_closing_date
        priority
        user_selected
        created_by
        created_at
        updated_at
        impact_level_name
        outcome_name
        project_name
        goals_static_name
        goal_for
        skills {
          skill_id
          skill_name
          id
        }
        attachments {
          id
          file_name
          file_path
          file_type
          uploaded_at
          idea_goal_id
        }
        followers {
          id
          follower_user_id
          followed_at
          is_follow
          idea_goal_id
          employee_name
        }
      }
    }
  }
`;

export const PROJECTS_BY_EMP_ID_IDEA_BOX = gql`
  query Projects_by_emp_id($emp_id: String!, $organization_id: String!) {
    projects_by_emp_id(emp_id: $emp_id, organization_id: $organization_id) {
      id
      name
    }
  }
`;

export const EXPORT_ATTTENDANCE_TO_EXCEL = gql`
  query Export_attendance_to_excel($input: AttendanceExportInput!) {
    export_attendance_to_excel(input: $input) {
      status
      message
      status_code
      file_url
      filename
      content_type
    }
  }
`;

export const GET_TIME_DISTRIBUTION_BY_SKILLS = gql`
  query Get_employee_time_distribution_by_skills(
    $employee_id: Int!
    $start_date: Date!
    $end_date: Date!
  ) {
    get_employee_time_distribution_by_skills(
      employee_id: $employee_id
      start_date: $start_date
      end_date: $end_date
    ) {
      status
      message
      status_code
      skill_groups {
        skill_id
        skill_name
        task_count
        estimated_hours
        actual_hours
      }
    }
  }
`;

export const GET_EMPLOYEE_GOALS_BY_SKILL = gql`
  query Get_employee_goals_by_skill(
    $employee_id: Int!
    $start_date: Date!
    $end_date: Date!
    $skill_id: Int
    $page: Int
    $page_size: Int
  ) {
    get_employee_goals_by_skill(
      employee_id: $employee_id
      start_date: $start_date
      end_date: $end_date
      skill_id: $skill_id
      page: $page
      page_size: $page_size
    ) {
      status
      message
      status_code
      pagination {
        total_pages
        current_page
        total_items
        has_next
        has_previous
      }
      goals {
        goal_id
        goal_name
        skill_name
        goal_type
        goal_status
        goal_tags
        start_date
        end_date
        employee_task_count
        total_task_count
        employee_estimated_hours
        employee_actual_hours
        overall_goal_estimated_hours
        overall_goal_actual_hours
      }
    }
  }
`;

export const GET_EMPLOYEE_PROJECTS_BY_SKILL = gql`
  query Get_employee_projects_by_skill(
    $employee_id: Int!
    $start_date: Date!
    $end_date: Date!
    $skill_id: Int
    $page: Int
    $page_size: Int
  ) {
    get_employee_projects_by_skill(
      employee_id: $employee_id
      start_date: $start_date
      end_date: $end_date
      skill_id: $skill_id
      page: $page
      page_size: $page_size
    ) {
      status
      message
      status_code
      pagination {
        total_pages
        current_page
        total_items
        has_next
        has_previous
      }
      projects {
        project_id
        project_name
        skill_name
        employee_goal_count
        total_goal_count
        employee_task_count
        total_task_count
        employee_estimated_hours
        employee_actual_hours
        overall_project_estimated_hours
        overall_project_actual_hours
      }
    }
  }
`;

export const GET_EMPLOYEE_TEAM_MEMBERS = gql`
  query Get_employee_team_members(
    $employee_id: Int!
    $start_date: Date!
    $end_date: Date!
  ) {
    get_employee_team_members(
      employee_id: $employee_id
      start_date: $start_date
      end_date: $end_date
    ) {
      status
      message
      status_code
      team_members {
        employee_id
        employee_name
        shared_goals_count
      }
    }
  }
`;

export const USER_EMPLOYEE_BY_EMPLOYEE_ID = gql`
  query Employee_by_employee_id($employee_id: Int!) {
    employee_by_employee_id(employee_id: $employee_id) {
      status
      message
      status_code
      employees {
        employee_id
        sex
        dob
        date_of_joining
        designation
        address
        state_name
        city_id
        contact_no
        email_id
        image_url
        first_name
        last_name
        skills {
          id
          proficiency_level
          years_of_experience
          certified
          assigned_date
          skill_name
          skill_id
        }
      }
    }
  }
`;

export const GET_EMPLOYEE_TIME_DISTRIBUTION_BY_CLIMB_TYPE = gql`
  query Get_employee_time_distribution_by_climb_type(
    $employee_id: Int!
    $start_date: Date!
    $end_date: Date!
  ) {
    get_employee_time_distribution_by_climb_type(
      employee_id: $employee_id
      start_date: $start_date
      end_date: $end_date
    ) {
      status
      message
      status_code
      climb_type_groups {
        climb_type
        task_count
        estimated_hours
        actual_hours
      }
    }
  }
`;

export const GET_EMPLOYEE_GOALS_BY_CLIMB_TYPE = gql`
  query Get_employee_goals_by_climb_type(
    $employee_id: Int!
    $start_date: Date!
    $end_date: Date!
    $climb_type: String
    $page: Int
    $page_size: Int
  ) {
    get_employee_goals_by_climb_type(
      employee_id: $employee_id
      start_date: $start_date
      end_date: $end_date
      climb_type: $climb_type
      page: $page
      page_size: $page_size
    ) {
      status
      message
      status_code
      pagination {
        total_pages
        current_page
        total_items
        has_next
        has_previous
      }
      goals {
        goal_id
        goal_name
        climb_type
        goal_type
        goal_status
        goal_tags
        start_date
        end_date
        employee_task_count
        total_task_count
        employee_estimated_hours
        employee_actual_hours
        overall_goal_estimated_hours
        overall_goal_actual_hours
      }
    }
  }
`;

export const GET_EMPLOYEE_PROJECTS_BY_CLIMB_TYPE = gql`
  query Get_employee_projects_by_climb_type(
    $employee_id: Int!
    $start_date: Date!
    $end_date: Date!
    $climb_type: String
    $page: Int
    $page_size: Int
  ) {
    get_employee_projects_by_climb_type(
      employee_id: $employee_id
      start_date: $start_date
      end_date: $end_date
      climb_type: $climb_type
      page: $page
      page_size: $page_size
    ) {
      status
      message
      status_code
      pagination {
        total_pages
        current_page
        total_items
        has_next
        has_previous
      }
      projects {
        project_id
        project_name
        climb_type
        employee_goal_count
        total_goal_count
        employee_task_count
        total_task_count
        employee_estimated_hours
        employee_actual_hours
        overall_project_estimated_hours
        overall_project_actual_hours
      }
    }
  }
`;

export const GET_EMPLOYEE_PEER_POINTS_FOR_MONTH = gql`
  query Get_employee_peer_points_for_month(
    $employee_id: Int!
    $month: Int!
    $year: Int!
  ) {
    get_employee_peer_points_for_month(
      employee_id: $employee_id
      month: $month
      year: $year
    ) {
      status
      message
      status_code
      summary {
        points_given
        points_earned
        remaining_balance
        month
        year
      }
    }
  }
`;

export const GET_EMPLOYEE_PEER_POINTS_FOR_MONTH_DETAILED = gql`
  query Get_employee_peer_points_for_month_detailed(
    $employee_id: Int!
    $month: Int!
    $year: Int!
  ) {
    get_employee_peer_points_for_month_detailed(
      employee_id: $employee_id
      month: $month
      year: $year
    ) {
      status
      message
      status_code
      points_given {
        id
        point
        reason
        given_by
        created_by
        created_on
        receiver_employee_id
        receiver_full_name
        giver_employee_id
        giver_full_name
        agency_id
      }
      points_earned {
        id
        point
        reason
        given_by
        created_by
        created_on
        receiver_employee_id
        receiver_full_name
        giver_employee_id
        giver_full_name
        agency_id
      }
    }
  }
`;

export const GET_EMPLOYEE_PEER_POINTS_FOR_DATE_RANGE = gql`
  query Get_employee_peer_points_for_date_range(
    $employee_id: Int!
    $start_date: Date!
    $end_date: Date!
  ) {
    get_employee_peer_points_for_date_range(
      employee_id: $employee_id
      start_date: $start_date
      end_date: $end_date
    ) {
      status
      message
      status_code
      summary {
        total_points_given
        total_points_earned
        start_date
        end_date
        monthly_breakdown {
          month
          year
          points_given
          points_earned
        }
      }
    }
  }
`;

export const GET_AGENCY_PEER_POINT_PER_MONTH = gql`
  query Get_agency_peer_point_per_month($agency_id: Int!) {
    get_agency_peer_point_per_month(agency_id: $agency_id) {
      status
      message
      status_code
      agency_peer_points {
        id
        peer_point_per_month
        created_on
        created_by
        updated_on
        updated_by
      }
    }
  }
`;

export const HOLIDAYS = gql`
  query Holidays($start_date: DateTime, $end_date: DateTime) {
    holidays(start_date: $start_date, end_date: $end_date) {
      status
      message
      status_code
      holidays {
        id
        day
        date
        type
        name
        agencies_id
        created_by
        created_on
        updated_by
        updated_on
      }
    }
  }
`;

export const GET_PEER_POINTS_LEADERBOARD = gql`
  query Get_peer_points_leaderboard(
    $agency_id: Int!
    $month: Int!
    $year: Int!
  ) {
    get_peer_points_leaderboard(
      agency_id: $agency_id
      month: $month
      year: $year
    ) {
      status
      message
      status_code
      leaderboard {
        rank
        employee_id
        employee_name
        employee_image_url
        total_points
      }
    }
  }
`;

export const MIGRATION_AGENCIES = gql`
  query Migration_agencies($progress_status: AgencyProgressStatus) {
    migration_agencies(progress_status: $progress_status) {
      status
      status_code
      agencies {
        id
        old_agency_id
        new_agency_id
        agency_name
        total_clients
        total_caregivers
        total_employees
        onboarding_date
        data_migration_date
        cx_member
        cx_member_2
        progress_status
        created_at
        updated_at
        agency_field_statuses {
          id
          has_issue
          is_complete
          need_validation
          remarks
          created_at
          updated_at
          field_name
        }
        assigned_members {
          id
          member_id
          assigned_by
          created_at
          member_first_name
          member_last_name
          member_full_name
        }
        verification_start_date
        verification_working_days
        completed_units
        total_units
      }
      message
    }
  }
`;

export const AGENCY_PROGRESS_STATUS = gql`
  query Agency_progress_statuses {
    agency_progress_statuses {
      value
      label
    }
  }
`;

export const MIGRATION_AGENCY_BY_ID = gql`
  query Migration_agency_by_id($agency_id: Int!) {
    migration_agency_by_id(agency_id: $agency_id) {
      status
      message
      status_code
      agency {
        id
        old_agency_id
        new_agency_id
        agency_name
        total_clients
        total_caregivers
        total_employees
        total_prospects
        onboarding_date
        verification_start_date
        verification_working_days
        data_migration_date
        cx_member
        cx_member_2
        progress_status
        agency_type
        created_at
        updated_at
        assigned_team_members {
          id
          member_id
          assigned_by
          created_at
        }
      }
    }
  }
`;

export const AGENCY_FIELD_STATUSES = gql`
  query Agency_field_statuses($agency_id: Int!) {
    agency_field_statuses(agency_id: $agency_id) {
      status
      message
      status_code
      field_statuses {
        field_id
        field_name
        field_description
        has_issue
        is_complete
        need_validation
        remarks
        status_id
      }
    }
  }
`;

export const MIGRATION_ENTITIES_BY_AGENCY = gql`
  query Migration_entities_by_agency(
    $agency_id: Int!
    $entity_type: String
    $progress_status: EntityProgressStatus
  ) {
    migration_entities_by_agency(
      agency_id: $agency_id
      entity_type: $entity_type
      progress_status: $progress_status
    ) {
      status
      message
      status_code
      total_count
      entities {
        id
        old_uuid
        new_uuid
        first_name
        middle_name
        last_name
        entity_type
        progress_status
        created_at
        updated_at
        member_id
      }
    }
  }
`;

export const ENTITY_FIELD_STATUSES = gql`
  query Entity_field_statuses($entity_id: Int!) {
    entity_field_statuses(entity_id: $entity_id) {
      status
      message
      status_code
      field_statuses {
        id
        agency_id
        entity_type
        has_issue
        is_complete
        need_validation
        remarks
        created_at
        updated_at
        field_name
      }
    }
  }
`;

export const ENTITY_PROGRESS_STATUSES = gql`
  query Entity_progress_statuses {
    entity_progress_statuses {
      value
      label
    }
  }
`;

export const ENTITY_FIELD_STATUS_REPORT = gql`
  query Entity_field_status_report($agency_id: Int!, $has_issue: Boolean) {
    entity_field_status_report(agency_id: $agency_id, has_issue: $has_issue) {
      status
      message
      status_code
      records {
        status_id
        entity_id
        entity_old_uuid
        entity_new_uuid
        entity_first_name
        entity_middle_name
        entity_last_name
        entity_type
        progress_status
        field_id
        field_name
        has_issue
        is_complete
        need_validation
        remarks
        member_id
        member_first_name
        member_last_name
      }
    }
  }
`;

export const AGENCY_DAY_OFFS = gql`
  query Agency_day_offs(
    $agency_id: Int!
    $start_date: Date!
    $end_date: Date!
    $is_active: Boolean
  ) {
    agency_day_offs(
      agency_id: $agency_id
      start_date: $start_date
      end_date: $end_date
      is_active: $is_active
    ) {
      status
      message
      status_code
      agency_day_offs {
        id
        day_off_date
        reason
        is_paid
        is_active
      }
    }
  }
`;

export const FEATURE_PROJECT_GOALS = gql`
  query Project_goals($is_archived: Boolean,$project_id:Int!) {
    project_goals(project_id: $project_id, is_archived: $is_archived) {
      status
      message
      status_code
      grouped_goals {
        status_name
        status_id
        goals {
          title
          goal_score
          is_archive
          start_date
          end_date
          description
          created_by_name
          number_of_tasks
          number_of_completed_tasks
          goal_status
          goal_static_outcome
          tasks {
            id
            title
            assigned_to_id
            assigned_to_name
          }
          goal_members {
            id
            member_name
            employee_id
          }
        }
      }
    }
  }
`;

export const SCREENS_BY_PROJECT = gql`
  query Screens_by_project($project_id: Int!) {
    screens_by_project(project_id: $project_id) {
      id
      name
      description
      release_date
      created_by
      created_on
      updated_by
      updated_on
      figma_url
      frontend_developer_id
      frontend_developer_name
      backend_developer_id
      backend_developer_name
      qa_id
      qa_name
      pod_name
      apis {
        id
        api_name
        api_endpoint
        description
      }
    }
  }
`;

export const SCREEN_BY_ID = gql`
  query Screen_by_id($screen_id: Int!) {
    screen_by_id(screen_id: $screen_id) {
      id
      name
      description
      release_date
      frontend_developer_name
      backend_developer_name
      qa_name
      history {
        id
        worked_by_name
        changes_made
        worked_on
      }
    }
  }
`;
export const PROJECT_GOALS_SHORT = gql`
  query Project_goals_short(
    $employee_id: Int
    $is_archived: Boolean
    $goal_status: String
    $start_date: Date
    $end_date: Date
  ) {
    project_goals_short(
      employee_id: $employee_id
      is_archived: $is_archived
      goal_status: $goal_status
      start_date: $start_date
      end_date: $end_date
    ) {
      status
      message
      status_code
      grouped_goals {
        status_name
        status_id
        goals {
          id
          title
          start_date
          end_date
          created_by
          actual_start_date
          actual_end_date
          goal_static_outcome
          project_name
          pod_id
          goal_members {
            id
            member_name
            employee_id
          }
        }
      }
    }
  }
`;

export const PODS_DATA = gql`
  query Pods_data($agency_id: Int!, $start_date: Date!, $end_date: Date!) {
    pods_data(
      agency_id: $agency_id
      start_date: $start_date
      end_date: $end_date
    ) {
      status
      message
      status_code
      data {
        pod_id
        pod_name
        members {
          employee_id
          first_name
          last_name
          total_working_hours
          allocated_working_hours
          utilization_percentage
          is_over_utilized
          is_available
          employee_role
          skill_set
        }
      }
    }
  }
`;

export const PODS_DATA_ATTENDANCE = gql`
  query Pods_data($agency_id: Int!, $start_date: Date!, $end_date: Date!) {
    pods_data(
      agency_id: $agency_id
      start_date: $start_date
      end_date: $end_date
    ) {
      status
      message
      status_code
      data {
        pod_id
        pod_name
        members {
          employee_id
          first_name
          last_name
        }
      }
    }
  }
`;

export const PODS_DATA_LIST = gql`
  query Pods_data($agency_id: Int!, $start_date: Date!, $end_date: Date!) {
    pods_data(
      agency_id: $agency_id
      start_date: $start_date
      end_date: $end_date
    ) {
      status
      message
      status_code
      data {
        pod_id
        pod_name
      }
    }
  }
`;


export const TODO_HISTORY_QUERY = gql`
  query Todo_history(
    $member_id: Int!
    $start_date: Date!
    $end_date: Date!
  ) {
    todo_history(
      member_id: $member_id
      start_date: $start_date
      end_date: $end_date
    ) {
      status
      message
      status_code
      todos {
        id
        title
        due_date
        is_completed
        completed_date
        created_by
        create_date
        updated_by
        updated_on
        is_email_send
        description
        todo_assigned_user_name
        created_by_name
        meeting_title
        meeting_id
        todo_assigned_user {
          employee_id
          email_id
          first_name
          last_name
        }
      }
    }
  }
`;

export const GET_ALL_ROLES = gql`
query Get_all_roles {
    get_all_roles {
        status
        message
        status_code
        data {
            id
            role_name
            createdon
            updatedon
        }
    }
}
`

// BuildPack template system queries
export const GOAL_TEMPLATES = gql`
  query GoalTemplates {
    goal_templates {
      status
      total
      templates {
        template_id
        title
        fleet
        cadence_or_trigger
        organizational_outcome
      }
    }
  }
`;

export const GOAL_TEMPLATE = gql`
  query GoalTemplate($template_id: String!) {
    goal_template(template_id: $template_id) {
      status
      template {
        template_id
        title
        fleet
        cadence_or_trigger
        definition
      }
    }
  }
`;

export const GOAL_TEMPLATES_BY_POD = gql`
  query Goal_templates_by_pod($pod_id: Int!) {
    goal_templates_by_pod(pod_id: $pod_id) {
      status
      message
      status_code
      total
      templates {
        id
        template_id
        fleet
        organizational_outcome
        owner_pod
        cadence_or_trigger
        version
        title
        definition
        chartered_by
        chartered_at
        created_at
        created_by
      }
    }
  }
`;

export const POD_GOALS_BY_ACTION_TYPE = gql`
  query Pod_goals_by_action_type(
    $pod_id: Int!
    $start_date: Date!
    $end_date: Date!
  ) {
    pod_goals_by_action_type(
      pod_id: $pod_id
      start_date: $start_date
      end_date: $end_date
    ) {
      status
      message
      status_code
   action_type_groups {
            action_type
            
            goals {
                id
                title
                start_date
                end_date
                created_by
                goal_status
                goal_static_outcome
                project_name
                defect {
                    module
                    classification_type
                    symptom
                    request_type
                    flags
                    churn_quote
                    category
                }
                goal_members {
                    employee_id
                    member_name
                    role
                }
            }
        }
    }
  }
`;

export const PODS_GOAL_SUMMARY = gql`
  query Pods_goal_summary(
    $agency_id: Int!
    $start_date: Date!
    $end_date: Date!
    $today: Date
  ) {
    pods_goal_summary(
      agency_id: $agency_id
      start_date: $start_date
      end_date: $end_date
      today: $today
    ) {
      status
      message
      status_code
      total_open_goals
      goals_ending_today
      delayed_goals
      pods {
        pod_id
        pod_name
        pod_type
        open_goal_count
        action_type_counts {
          action_type
          count
        }
      }
    }
  }
`;


export const DEFECT_HISTORY = gql`
  query Defect_history($defect_id: Int!) {
    defect_history(defect_id: $defect_id) {
      status
      message
      status_code
      history {
        id
        defect_id
        changed_by
        old_pod_id
        new_pod_id
        old_action_type
        new_action_type
        changed_on
        summary
      }
    }
  }
`;

export const GET_POD_GOAL = gql`
    query Get_pod_goal($goal_id: Int!) {
        get_pod_goal(goal_id: $goal_id) {
            status
            message
            status_code
            goal {
                id
                title
                description
                start_date
                end_date
                status
                created_by
                created_on
                updated_by
                updated_on
                pod_id
                
                tasks {
                    id
                    start_datetime
                    end_datetime
                    
                    sequence
                    created_on
                    updated_on
                    task
                    tag
                    doer
                    assigned_to_id
                    assigned_to_name
                    checklists {
                        id
                        ticked
                        ticked_by
                        ticked_at
                        sequence
                        checklist_item
                        kind
                    }
                }
            }
            members {
                employee_id
                first_name
                last_name
                designation
                image_url
                skills
                is_cs_person
            }
        }
    }
`;

export const GET_RESOURCE_WORKING_DATES = gql`
  query Resource_working_dates($start_date: DateTime!, $employee_id: Int,$pod_id:Int) {
    resource_working_dates(start_date: $start_date, employee_id: $employee_id,pod_id:$pod_id) {
         status
        message
        status_code
        total
        records {
            id
            employee_id
            start_date
            end_date
            notes
            created_by
            created_on
            updated_by
            updated_on
            employee_name
            pod_name
            designation
            leave_status
        }
    }
  }
`;

export const LEAVES_BY_POD = gql`
  query Leaves_by_pod($current_date: DateTime!, $number_of_days: Int!, $pod_id: Int) {
    leaves_by_pod(
      current_date: $current_date
      number_of_days: $number_of_days
      pod_id: $pod_id
    ) {
      status
      message
      status_code
      total
      records {
        id
        start_date
        end_date
        notes
        reason
        is_half_day
        employee_name
        pod_name
        leave_type
        from_to
        status
      }
    }
  }
`;

export const EMPLOYEE_ACTIVE_STATS = gql`
  query Employee_active_stats($target_date: DateTime!) {
    employee_active_stats(target_date: $target_date) {
      status
      message
      status_code
      total
        records {
            employee_id
            active_goal_count
            active_task_count
            total_meetings
            present_count
            absent_count
            meeting_details {
                date
                total_meetings
                meetings {
                    meeting_id
                    title
                    time
                    status
                    pod_id
                    pod_name
                    meeting_type_name
                      start_datetime
                      end_datetime
                }
            }
        }
    }
  }
`;

export const EMPLOYEE_ACTIVE_STATS_RESOURCES = gql`
  query Employee_active_stats($target_date: DateTime!) {
    employee_active_stats(target_date: $target_date) {
      status
      message
      status_code
      total
        records {
            employee_id
            active_goal_count
            active_task_count
        }
    }
  }
`;

export const CHECK_OVERNIGHT_SHIFT = gql`
  query Check_overnight_shift(
    $target_date: DateTime!
    $employee_id: Int!
  ) {
    check_overnight_shift(
      target_date: $target_date
      employee_id: $employee_id
    ) {
      status
      message
      status_code
      record {
        employee_id
        is_overnight_shift
      }
    }
  }
`;
export const EMPLOYEE_LEAVE_SUMMARY = gql`
  query EmployeeLeaveSummary($agency_id: Int!, $start_date: Date!, $end_date: Date!) {
    employee_leave_summary(
      agency_id: $agency_id
      start_date: $start_date
      end_date: $end_date
    ) {
      status
      message
      status_code
      records {
        employee_id
        employee_name
        date_of_joining
        leaves {
          id
          start_date
          end_date
          leave_type
          is_half_day
          pay_type
        }
      }
    }
  }
`;

export const POD_GOAL_TEMPLATES = gql`
  query Pod_goal_templates($pod_id: Int!) {
    pod_goal_templates(
      pod_id: $pod_id
    ) {
      status
      message
      status_code
      goal_templates {
            id
            name
            tag
            tasks {
                id
                name
                tag
                doer
                sequence
                associated_goal_ids
                checklists {
                    id
                    name
                    kind
                    sequence
                    status
                }
            }
        }
    }
  }
`;

export const GET_MEETING_NOTES = gql`
    query Get_meeting_notes(
        $start_date: Date!
        $page: Int
        $page_size: Int
    ) {
        get_meeting_notes(
            start_date: $start_date
            page: $page
            page_size: $page_size
        ) {
            status
            message
            status_code
            meeting_notes {
                id
                meeting_id
                meeting_date
                meeting_time
                meeting_time_ist
                meeting_duration
                participant_name
                transcript
                support_agent
                meeting_title
                meeting_summary
                action_items
                meeting_type
                agency_name
                recording_url
                agency_id
            }
            pagination {
                total_pages
                current_page
                total_items
                has_next
                has_previous
            }
        }
    }
`;

export const GET_CUSTOMER_EMAILS = gql`
  query Get_customer_emails(
    $date: Date!
    $page: Int
    $page_size: Int
  ) {
    get_customer_emails(
      date: $date
      page: $page
      page_size: $page_size
    ) {
      status
      message
      status_code
      customer_emails {
        thread_id
        agency_name
        agency_id
        agency_email
        employee_id
        nature_of_email
        system
        replied_by
        is_replied
        conversation {
          type
          sender
          body
          time
          time_ist
        }
      }
      pagination {
        total_pages
        current_page
        total_items
        has_next
        has_previous
      }
    }
  }
`;